import { Language } from '../types';

const BASE_LANGUAGE_LABELS = {
  AL: 'Albania',
  DZ: 'Algeria',
  AI: 'Anguilla',
  AG: 'Antigua and Barbuda',
  AR: 'Argentina',
  AM: 'Armenia',
  AW: 'Aruba',
  AU: 'Australia',
  AT: 'Austria',
  BS: 'Bahamas',
  BH: 'Bahrain',
  BD: 'Bangladesh',
  BE: 'Belgium',
  BZ: 'Belize',
  BJ: 'Benin',
  BM: 'Bermuda',
  BA: 'Bosnia and Herzegovina',
  BT: 'Bhutan',
  BW: 'Botswana',
  BR: 'Brazil',
  BN: 'Brunei Darussalam',
  BG: 'Bulgaria',
  CM: 'Cameroon',
  CA: 'Canada',
  CV: 'Cape Verde',
  KY: 'Cayman Islands',
  TD: 'Chad',
  CL: 'Chile',
  CN: 'China',
  CO: 'Colombia',
  KM: 'Comoros',
  CG: 'Congo (The)',
  CR: 'Costa Rica',
  HR: 'Croatia',
  CY: 'Cyprus',
  CZ: 'Czech Republic',
  DK: 'Denmark',
  DM: 'Dominica',
  DO: 'Dominican Republic',
  EC: 'Ecuador',
  EG: 'Egypt',
  EE: 'Estonia',
  FJ: 'Fiji',
  FI: 'Finland',
  FR: 'France',
  GA: 'Gabon',
  GM: 'Gambia',
  GE: 'Georgia',
  DE: 'Germany',
  GH: 'Ghana',
  GI: 'Gibraltar',
  GR: 'Greece',
  GD: 'Grenada',
  GT: 'Guatemala',
  GN: 'Guinea',
  GY: 'Guyana',
  HN: 'Honduras',
  HK: 'Hong Kong',
  HU: 'Hungary',
  IS: 'Iceland',
  IN: 'India',
  ID: 'Indonesia',
  IE: 'Ireland',
  IL: 'Israel',
  IT: 'Italy',
  JP: 'Japan',
  KZ: 'Kazakhstan',
  KE: 'Kenya',
  KW: 'Kuwait',
  KG: 'Kyrgyzstan',
  LV: 'Latvia',
  LS: 'Lesotho',
  LI: 'Liechtenstein',
  LT: 'Lithuania',
  LU: 'Luxembourg',
  MO: 'Macao',
  MK: 'Macedonia',
  MG: 'Madagascar',
  MW: 'Malawi',
  MY: 'Malaysia',
  MT: 'Malta',
  MU: 'Mauritius',
  MX: 'Mexico',
  MD: 'Moldova',
  MN: 'Mongolia',
  MS: 'Montserrat',
  MZ: 'Mozambique',
  NA: 'Namibia',
  NP: 'Nepal',
  NL: 'Netherlands',
  NZ: 'New Zealand',
  NE: 'Niger',
  NO: 'Norway',
  PG: 'Papua New Guinea',
  PY: 'Paraguay',
  PE: 'Peru',
  PH: 'Philippines',
  PL: 'Poland',
  PT: 'Portugal',
  QA: 'Qatar',
  RO: 'Romania',
  RW: 'Rwanda',
  KN: 'Saint Kitts and Nevis',
  LC: 'Saint Lucia',
  VC: 'Saint Vincent and the Grenadines',
  SA: 'Saudi Arabia',
  RS: 'Serbia',
  SC: 'Seychelles',
  SL: 'Sierra Leone',
  SG: 'Singapore',
  SK: 'Slovakia',
  SI: 'Slovenia',
  SB: 'Solomon Islands',
  SV: 'El Salvador',
  ZA: 'South Africa',
  KR: 'South Korea',
  ES: 'Spain',
  LK: 'Sri Lanka',
  SE: 'Sweden',
  CH: 'Switzerland',
  TW: 'Taiwan',
  TJ: 'Tajikistan',
  TZ: 'Tanzania',
  TH: 'Thailand',
  TG: 'Togo',
  TO: 'Tonga',
  TN: 'Tunisia',
  TR: 'Turkey',
  UG: 'Uganda',
  UA: 'Ukraine',
  AE: 'United Arab Emirates',
  GB: 'United Kingdom',
  UY: 'Uruguay',
  UZ: 'Uzbekistan',
  VN: 'Viet Nam',
  WF: 'Wallis and Futuna',
  ZM: 'Zambia',
  AO: 'Angola',
  JO: 'Jordan',
  SZ: 'Swaziland',
  PA: 'Panama',
  US: 'United States',
  PR: 'Puerto Rico',
  CW: 'Curaçao',
};
type LabelsLanguage = keyof typeof BASE_LANGUAGE_LABELS;

const COUNTRIES_NAMES: Record<
  Language,
  Record<LabelsLanguage, string | object>
> = {
  EN: BASE_LANGUAGE_LABELS,
  ES: {
    AL: 'Albania',
    DZ: 'Argelia',
    AI: 'Anguila',
    AG: 'Antigua y Barbuda',
    AR: 'Argentina',
    AM: 'Armenia',
    AW: 'Aruba',
    AU: 'Australia',
    AT: 'Austria',
    BS: 'Bahamas',
    BH: 'Baréin',
    BD: 'Bangladés',
    BE: 'Bélgica',
    BZ: 'Belice',
    BJ: 'Benín',
    BM: 'Bermudas',
    BA: 'Bosnia y Herzegovina',
    BT: 'Bután',
    BW: 'Botsuana',
    BR: 'Brasil',
    BN: 'Brunéi',
    BG: 'Bulgaria',
    CM: 'Camerún',
    CA: 'Canadá',
    CV: 'Cabo Verde',
    KY: 'Islas Caimán',
    TD: 'Chad',
    CL: 'Chile',
    CN: 'China',
    CO: 'Colombia',
    KM: 'Comoras',
    CG: 'Congo (El)',
    CR: 'Costa Rica',
    HR: 'Croacia',
    CY: 'Chipre',
    CZ: 'Chequia',
    DK: 'Dinamarca',
    DM: 'Dominica',
    DO: 'República Dominicana',
    EC: 'Ecuador',
    EG: 'Egipto',
    EE: 'Estonia',
    FJ: 'Fiyi',
    FI: 'Finlandia',
    FR: 'Francia',
    GA: 'Gabón',
    GM: 'Gambia',
    GE: 'Georgia',
    DE: 'Alemania',
    GH: 'Ghana',
    GI: 'Gibraltar',
    GR: 'Grecia',
    GD: 'Granada',
    GT: 'Guatemala',
    GN: 'Guinea',
    GY: 'Guyana',
    HN: 'Honduras',
    HK: 'Hong Kong',
    HU: 'Hungría',
    IS: 'Islandia',
    IN: 'India',
    ID: 'Indonesia',
    IE: 'Irlanda',
    IL: 'Israel',
    IT: 'Italia',
    JP: 'Japón',
    KZ: 'Kazajistán',
    KE: 'Kenia',
    KW: 'Kuwait',
    KG: 'Kirguistán',
    LV: 'Letonia',
    LS: 'Lesoto',
    LI: 'Liechtenstein',
    LT: 'Lituania',
    LU: 'Luxemburgo',
    MO: 'Macao',
    MK: 'Macedonia del Norte',
    MG: 'Madagascar',
    MW: 'Malaui',
    MY: 'Malasia',
    MT: 'Malta',
    MU: 'Mauricio',
    MX: 'México',
    MD: 'Moldavia',
    MN: 'Mongolia',
    MS: 'Montserrat',
    MZ: 'Mozambique',
    NA: 'Namibia',
    NP: 'Nepal',
    NL: 'Países Bajos',
    NZ: 'Nueva Zelanda',
    NE: 'Níger',
    NO: 'Noruega',
    PG: 'Papúa Nueva Guinea',
    PY: 'Paraguay',
    PE: 'Perú',
    PH: 'Filipinas',
    PL: 'Polonia',
    PT: 'Portugal',
    QA: 'Catar',
    RO: 'Rumanía',
    RW: 'Ruanda',
    KN: 'San Cristóbal y Nieves',
    LC: 'Santa Lucía',
    VC: 'San Vicente y las Granadinas',
    SA: 'Arabia Saudita',
    RS: 'Serbia',
    SC: 'Seychelles',
    SL: 'Sierra Leona',
    SG: 'Singapur',
    SK: 'Eslovaquia',
    SI: 'Eslovenia',
    SB: 'Islas Salomón',
    SV: 'El Salvador',
    ZA: 'Sudáfrica',
    KR: 'Corea del Sur',
    ES: 'España',
    LK: 'Sri Lanka',
    SE: 'Suecia',
    CH: 'Suiza',
    TW: 'Taiwán',
    TJ: 'Tayikistán',
    TZ: 'Tanzania',
    TH: 'Tailandia',
    TG: 'Togo',
    TO: 'Tonga',
    TN: 'Túnez',
    TR: 'Turquía',
    UG: 'Uganda',
    UA: 'Ucrania',
    AE: 'Emiratos Árabes Unidos',
    GB: 'Reino Unido',
    UY: 'Uruguay',
    UZ: 'Uzbekistán',
    VN: 'Vietnam',
    WF: 'Wallis y Futuna',
    ZM: 'Zambia',
    AO: 'Angola',
    JO: 'Jordania',
    SZ: 'Esuatini',
    PA: 'Panamá',
    US: 'Estados Unidos',
    PR: 'Puerto Rico',
    CW: 'Curazao',
  },
};

export default COUNTRIES_NAMES;
